<template>
  <section v-if="items.length" class="resources-faq">
    <h2 class="resources-faq__title" v-html="getTitleBlock(page, 'faq', 'title')"></h2>
    <div class="resources-faq__list">
      <Accordion
        v-for="(item, index) in items"
        :key="index"
        class="resources-faq__item"
        :initial-open="index === 0"
      >
        <template v-slot:title>
          <span class="resources-faq__question" v-html="item.key"></span>
        </template>
        <p class="resources-faq__answer" v-html="item.value"></p>
      </Accordion>
    </div>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { Accordion } from '@/shared/ui/accordion';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
  components: { Accordion },
  computed: {
    items() {
      return this.getListBlock(this.page, 'faq-list');
    },
  },
};
</script>

<style lang="scss" scoped>
.resources-faq {
  max-width: 928px;
  margin: 0 auto;
  padding: 140px 24px 0;

  @media (max-width: 800px) {
    padding: 72px 16px 0;
  }

  &__title {
    margin: 0 0 40px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.15;
    text-align: center;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__item {
    margin-bottom: 0;
  }

  &__question {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
    color: #373A3D;
  }

  &__answer {
    margin: 0;
    padding-bottom: 24px;
    font-size: 17px;
    line-height: 26px;
    color: #4E5358;
  }
}
</style>
